export const openCanvas = (id) => {
    const canvas1 = document.getElementById(id);
    canvas1.classList.remove('hiding');
    canvas1.classList.add('showing', 'show');
}
export const closeCanvas = (id) => {
    const canvas2 = document.getElementById(id);
    canvas2.classList.remove('showing', 'show');
    canvas2.classList.add('hiding');
}